module.exports = __webpack_public_path__ + "img/me_active.e6202a4d.svg";